/* Copyright (c) 2023 Xperi. All Rights Reserved. */

import { PostSignInError } from './PostSignInError';

export class MsoServiceIdNotFoundError extends PostSignInError {
    TAG: string = 'MsoServiceIdNotFoundError';

    constructor(message: string, code: string, description: string) {
        super(code, message);
        this.description = description;
        this.type = 'MSO_SERVICE_ID_NOT_FOUND_ERROR';
    }
}
